import { getFirebaseIDToken } from "@/api/auth/firebase"
import { axiosInstance } from "@/api/axiosInstance"
import { AxiosRequestConfig } from "axios"
import { PlayerBonusQuestionApi } from "swagger/api"
import { Configuration } from "swagger/configuration"
import { PlayBonusQuestionRequest } from "swagger/models"

const getAccessToken = async () => {
  const accessToken = await getFirebaseIDToken()
  return accessToken
}

const getApiConfig = () =>
  new Configuration({
    basePath: process.env.NEXT_PUBLIC_API_URL,
    //@ts-ignore
    accessToken: getAccessToken,
  })

const apiConfiguration = getApiConfig()

const BONUS_QUESTION_API = new PlayerBonusQuestionApi(apiConfiguration, apiConfiguration.basePath, axiosInstance)

export const getBonusQuestion = async (bonusQuestionId: string, options?: AxiosRequestConfig) =>
  BONUS_QUESTION_API.getBonusQuestion(bonusQuestionId, options)

export const playBonusQuestion = async (
  body: PlayBonusQuestionRequest,
  bonusQuestionId: string,
  options?: AxiosRequestConfig,
) => BONUS_QUESTION_API.playBonusQuestion(body, bonusQuestionId, options)
